/**
 * SettingCardContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const SettingCardContainer = styled.div<{ focused?: boolean; hide?: boolean }>`
  align-items: center;
  background: linear-gradient(109deg, #4a4a4a 4.1%, #202020 96.58%);
  border: ${3 * Screen.widthRatio}px solid
    ${(props) => (props.focused ? '#FFFFFF' : '#5F5F5F')};
  border-radius: ${20 * Screen.widthRatio}px;
  cursor: pointer;
  display: ${(props) => (props.hide ? 'none' : 'flex')};
  flex-direction: column;
  float: left;
  height: ${191 * Screen.widthRatio}px;
  justify-content: center;
  margin-right: ${8 * Screen.widthRatio}px;
  margin-bottom: ${16 * Screen.widthRatio}px;
  width: ${344 * Screen.widthRatio}px;
`;

export default SettingCardContainer;
